
export const getPayload = (props) => {
    const {variant, engine, prices, responseSummary, loantype, gfv, disclaimer, description} = props;
    let payload = {
        vehicleImageUrl: prices ? prices.ImagePath : "",
        modelName: variant ? variant.name : "",
        modelYear: engine ? engine.year : "",
        engine: engine ? engine.name : "",
        loanType: loantype === "ConsumerLoan" ? "Personal loan" : "Business loan",
        loanOption: gfv === "AudiChoice" ? "Audi Choice" : "Standard loan",
        disclaimer: disclaimer,
        description: description
    };
    if (responseSummary.DriveawayPrice) {
        payload.vehiclePrice = `${responseSummary.DriveawayPrice.units}${responseSummary.DriveawayPrice.value}`;
    }
    if (responseSummary.Rate) {
        payload.repayment = `${responseSummary.Rate.units}${responseSummary.Rate.value}`;
        payload.repaymentLabel = `${responseSummary.Rate.label}`;
    }
    if (responseSummary.ComparisonRate) {
        payload.comparisonRate = `${responseSummary.ComparisonRate.value}${responseSummary.ComparisonRate.units}`;
    }
    if (responseSummary.AnnualRate) {
        payload.annualRate = `${responseSummary.AnnualRate.value}${responseSummary.AnnualRate.units}`;
    }
    if (responseSummary.TotalAmountPayable) {
        payload.totalRepayment = `${responseSummary.TotalAmountPayable.units}${responseSummary.TotalAmountPayable.value}`;
    }
    if (responseSummary.Term) {
        payload.loanTerm = `${responseSummary.Term.value}`;
    }
    if (responseSummary.DownPayment) {
        payload.deposit = `${responseSummary.DownPayment.units}${responseSummary.DownPayment.value}`
    }
    if (responseSummary.Balloon && responseSummary.BalloonAmount) {
        payload.balloon = `${responseSummary.Balloon.value}${responseSummary.Balloon.units}`;
        payload.balloonAmount = `${responseSummary.BalloonAmount.units}${responseSummary.BalloonAmount.value}`;
    }
    if (responseSummary.KMLimit) {
        payload.kmLimit = `${responseSummary.KMLimit.value}${responseSummary.KMLimit.units}`;
    }
    if (responseSummary.GuaranteedFutureValue) {
        payload.gfv = `${responseSummary.GuaranteedFutureValue.units}${responseSummary.GuaranteedFutureValue.value}`;
    }
    return payload;
}
